import { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogActions, DialogContent, CircularProgress, Button, Typography, Box, Chip} from "@mui/material";
import axiosInstance from "../../../Config/axiosInstance";
import "./EvaluationScore.css";

const EvaluationScoreList = ({ open, onClose, supplierId }) => {
  const [criteria, setCriteria] = useState([]);
  const [existingScores, setExistingScores] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const criteriaRes = await axiosInstance.get('/evaluation-criterion/evaluationCriterion/?is_active=true')
        setCriteria(criteriaRes.data);

        const scoresRes = await axiosInstance.get(
          `/supplier-evaluation/?evaluation=${supplierId}`
        );

        const scores = scoresRes.data;

        const scoreMap = {};

        scores.forEach((score) => {
          const key = String(score.criterion);
          const existing = scoreMap[key];
          if(!existing || new Date(score.created_at) > new Date(existing.created_at)){
            scoreMap[key] = score;
          }
        });

        const formattedScores = {};
        Object.keys(scoreMap).forEach((key) => {
          formattedScores[key] = scoreMap[key].score;
        });

        setExistingScores(formattedScores);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    if (open) {
      fetchData();
    }
  }, [open, supplierId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Supplier Evaluation Overview</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" py={4}>
            <CircularProgress />
          </Box>
        ) : criteria.length === 0 ? (
          <Typography>No active evaluation criteria found.</Typography>
        ) : (
          criteria.map((criterion) => (
          <Box
            key={criterion.id}
            className="evaluation-item"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box className="evaluation-label" flex="1">
              <Typography>{criterion.label}</Typography>
            </Box>
            <Box>
              {existingScores[String(criterion.id)] !== undefined ? (
                <Typography className="evaluation-score">
                  Score: {existingScores[String(criterion.id)]}
                </Typography>
              ) : (
                <Chip label="Not scored" color="default" size="small" />
              )}
            </Box>
          </Box>
          ))
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EvaluationScoreList;
